import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaseManagementWorkRequestStatusAddRoutingModule } from './case-management-work-request-status-add-routing.module';
import { CaseManagementWorkRequestStatusAddComponent } from './case-management-work-request-status-add.component';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    CaseManagementWorkRequestStatusAddComponent
  ],
  imports: [
    CommonModule,
    CaseManagementWorkRequestStatusAddRoutingModule,
    DialogModule,
    SharedModule,
  ],
  exports: [
    CaseManagementWorkRequestStatusAddComponent
  ]
})
export class CaseManagementWorkRequestStatusAddModule { }
